var _style, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPbsCloseWhite = function SvgPbsCloseWhite(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "aria-hidden": "true",
    className: "pbs-close-white_svg__pbs-close-white",
    viewBox: "0 0 12.8 12.4"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".pbs-close-white_svg__pbs-close-white__path{fill:none;stroke:#fff;stroke-width:1.5;stroke-linecap:round;stroke-linejoin:round}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m.9 1 11 10.5M11.9 1 .9 11.5",
    className: "pbs-close-white_svg__pbs-close-white__path"
  })));
};
export default SvgPbsCloseWhite;